import { render, staticRenderFns } from "./PalletCoolingChamber.vue?vue&type=template&id=82a701ba"
import script from "./PalletCoolingChamber.vue?vue&type=script&lang=js"
export * from "./PalletCoolingChamber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports